/**
 * ManagementSection - TASK-371 (extracted from ClientProfileForm)
 * Section 2: Management type, reporting frequency, investment strategy.
 */

import React from 'react';
import type { ClientProfileFormData } from './ClientProfileForm';

type ManagementData = ClientProfileFormData['management'];

interface ManagementSectionProps {
  data: ManagementData;
  onChange: (field: string, value: any) => void;
}

export const ManagementSection: React.FC<ManagementSectionProps> = ({
  data,
  onChange,
}) => (
  <div className="px-4 pb-4 space-y-4">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">
          Management Type
        </label>
        <select
          value={data.type || ''}
          onChange={(e) => onChange('type', e.target.value || null)}
          className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select type</option>
          <option value="discretionary">Discretionary</option>
          <option value="advisory">Advisory</option>
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">
          Reporting Frequency
        </label>
        <select
          value={data.reporting_frequency || ''}
          onChange={(e) => onChange('reporting_frequency', e.target.value || null)}
          className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select frequency</option>
          <option value="monthly">Monthly</option>
          <option value="quarterly">Quarterly</option>
          <option value="semi-annual">Semi-Annual</option>
          <option value="annual">Annual</option>
        </select>
      </div>
    </div>
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">
        Investment Strategy
      </label>
      <textarea
        value={data.strategy || ''}
        onChange={(e) => onChange('strategy', e.target.value || null)}
        rows={3}
        className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
        placeholder="Describe the investment strategy and guidelines..."
      />
    </div>
  </div>
);

export default ManagementSection;
